import multiTab from './multiTab'

const zhCN = { multiTab: multiTab.zhCN }
const enUS = { multiTab: multiTab.enUS }
export default { zhCN, enUS }